import { ComponentProps } from 'react';

import { Icon } from 'components/Icon/Icon';

import { ArrowLinkIconContainer } from './ArrowLink.styled';
import { StyledNativeLinkWithRef } from './StyledNativeLinkWithRef';
import { UnstyledNativeLink } from './UnstyledNativeLink';

export function ArrowLink({
  open,
  children,
  ...props
}: ComponentProps<typeof UnstyledNativeLink> & { open?: boolean }) {
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledNativeLinkWithRef {...props}>
      {children}

      <ArrowLinkIconContainer className={open ? 'open' : ''}>
        <Icon name="chevron-down" size={24} />
      </ArrowLinkIconContainer>
    </StyledNativeLinkWithRef>
  );
}
